export default function CsharpTryCatch() {
  return (
    <h2>Csharp Try Catch</h2>
  );
}
